import { render } from "./AdrDatadogCase.vue?vue&type=template&id=74d8fe54"
import script from "./AdrDatadogCase.vue?vue&type=script&lang=js"
export * from "./AdrDatadogCase.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__